import { Component, OnInit, OnDestroy, Input, AfterViewInit, ViewChild, ElementRef, EventEmitter, Output, HostListener } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { AbstractControl, FormArray, FormBuilder, FormControl, FormGroup, ValidatorFn, Validators } from '@angular/forms';
import { AlertService, MessageSeverity, DialogType } from '../../services/alert.service';
import { UserLogin } from '../../models/user-login.model';
import { ICD, MasterConfig, ResponseAPI, ErrorList, ICDStep3 } from '../../models/IDPReport.model';
import { SfDataService } from '../../services/sf-data.service';
import { AgentService, PreSubmitIssue } from '../../services/agent.service';
import { AiHintStateService } from '../../services/ai-hint-state.service';
import { of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { AuthService } from '../../services/auth.service';
import { ConfigurationService } from '../../services/configuration.service';
import { Utilities } from '../../services/utilities';
import Swal from 'sweetalert2';



declare global {
  interface JQuery {
    datepicker(options?: any): any;
  }
}

interface JQuery<TElement = HTMLElement> {
  select2(options?: any): any;
}

interface JQuery {
  select2(options?: any): any;
}


// import custom validator to validate 
import { MustMatch } from '../../models/MustMatch';
import { dateNotLessThanTodayValidator } from '../../models/dateNotLessThanTodayValidator';


@Component({
    selector: 'app-sf-icd-closelocation',
    templateUrl: './sf-icd-closelocation.component.html',
    styleUrls: ['./sf-icd-closelocation.component.scss'],
    standalone: false
})

export class SfIcdCloselocationComponent implements OnInit, AfterViewInit {
  icd = new ICDStep3();
  data = {
    name: 'John',
    age: 30
  };

  userLogin = new UserLogin(); id: string; q: string; d: string; fm: string;
  isLoading = false;
  isTestCampaign = false;
  formResetToggle = true;
  modalClosedCallback: () => void;
  loginStatusSubscription: any;
  selectedCountry: string;
  Is_primary_location = false;
  selected_WC_details: string
  icdForm: FormGroup;
  section1Form: FormGroup;
  section2Form: FormGroup;
  section3Form: FormGroup;
  section4Form: FormGroup;
  section5Form: FormGroup;
  section6Form: FormGroup;

  @Input()
  isModal = false;
  submitted = false;
  ddlUSStates = [];
  ddlBest_Delivery_Time = [];
  ddlCAProvinence = [];

  Canada_campaignData = [];
  Canada_retailsData = [];

  PO_namesData = [];
  NC_namesData = [];
  RC_namesData = [];
  Locs_Data = [];

  US_campaignData = [];
  US_retailsData = [];
  icd_o = new ICD();
  @Output() dataEmitter = new EventEmitter<any>();
  @Input() inputData: any;
  selectedFiles: FileList;
  validFiles: File[] = [];
  fileData: { attachment_FileName: string, attachment_Base64: string, attachment_Type: string }[] = [];
  maxFilesAllowed: number = 15; // Maximum number of files allowed
  maxFileSize: number = 26214400; // Maximum file size in bytes (5MB)

  US_Retails_selectedItems: any[] = [];
  US_Retails_isSelectedItemsinvalid = false;
  Canada_Retails_selectedItems: any[] = [];
  Canada_Retails_isSelectedItemsinvalid = false;
  US_Campaigns_selectedItems: any[] = [];
  US_Campaigns_isSelectedItemsinvalid = false;
  Canada_Campaigns_selectedItems: any[] = [];
  Canada_Campaigns_isSelectedItemsinvalid = false;

  isOTPValid = false;
  btnDisplay = true;
  // Pre-submit review
  showPreSubmitReview = false;
  preSubmitIssues: PreSubmitIssue[] = [];
  preSubmitLoading = false;

  public masterConfig: MasterConfig[] = [];

  datad = {
    name: '',
    age: 0
  };

  @Output() idEmitter = new EventEmitter<string>();
  //@ViewChild('dobInput') dobInput: ElementRef;
  @ViewChild('datepicker') datepicker: ElementRef;
  @ViewChild('selectEl') selectEl: ElementRef;

  select2Options = {
    placeholder: 'Select an option...',
    width: '100%'
  };

  selectedOption: string;

  controlDisplayNames: { [key: string]: string } = {

    US_or_CA: 'Country',
    Is_primary_location: 'Is Main Location',
    selectedRow: 'New Main Location'
  };
  constructor(private route: ActivatedRoute, private elRef: ElementRef, private fb: FormBuilder, private router: Router, private alertService: AlertService, private authService: AuthService, private configurations: ConfigurationService, private sfDataService: SfDataService, private agentService: AgentService, private hintStateService: AiHintStateService) { }

  @Output() activateTab = new EventEmitter<number>();

  ngOnInit(): void {


    this.isLoading = true;
    this.alertService.startLoadingMessage('', 'Attempting login...');
    //this.emitActivateTab(3);
    $('.detailchild').removeClass('active');
    $('.detailmain').removeClass('active');
    $('#custom-tabs-four-more-tab').addClass('active');

    $('.detailchild').removeClass('tabhighlight');
    $('#custom-tabs-close-loc').addClass('tabhighlight');  
    $('#custom-tabs-four-more-tab').parent().addClass('active');

    this.id = this.route.snapshot.paramMap.get('id');

    this.fm = this.route.snapshot.paramMap.get('f');

    this.d = this.route.snapshot.paramMap.get('dcode');

    this.datad = this.inputData;
    this.CreateForm();

    this.BindDropdowns();
     
        this.idEmitter.emit(this.id);
        this.BindData(this.id,this.d);
     

  }

  @HostListener('contextmenu', ['$event'])
  onRightClick(event: Event): void {
    event.preventDefault();
  }
  ShowOTPpopup(str: string) {
    Swal.fire({
      title: 'OTP!',
      text: str,
      icon: 'warning',
      confirmButtonText: 'Ok',
      allowOutsideClick: false,
      allowEscapeKey: false,
      input: 'text',
      showLoaderOnConfirm: true,  // Show a loading spinner while the API call is in progress
      preConfirm: async (val) => {
        if (!val) {
          Swal.showValidationMessage("OTP is required");
        } else {
          try {

            // Create a new instance of the ICD class
            let responseAPI = new ResponseAPI();
            this.sfDataService.getOTP(this.id, val, this.q)
              .subscribe(
                data => {

                  //responseAPI = data;
                  // Assign the received data to the responseAPI object
                  responseAPI = data;
                  if (responseAPI.isSuccess) {
                    this.isOTPValid = responseAPI.isSuccess;
                    this.idEmitter.emit(this.id);
                    this.BindData(this.id,this.d);
                  }
                  else {
                    // API call failed, reject the Promise to prevent closing the popup
                    this.ShowOTPpopup("Wrong Access Code, Enter Access Code to continue");
                  }

                },
                error => {

                  this.alertService.stopLoadingMessage();

                  if (Utilities.checkNoNetwork(error)) {
                    this.alertService.showStickyMessage(Utilities.noNetworkMessageCaption, Utilities.noNetworkMessageDetail, MessageSeverity.error, error);
                    this.offerAlternateHost();
                  } else {
                    const errorMessage = Utilities.getHttpResponseMessage(error);

                    if (errorMessage) {
                      this.alertService.showStickyMessage('Unable to store data', this.mapLoginErrorMessage(errorMessage), MessageSeverity.error, error);
                    } else {
                      this.alertService.showStickyMessage('Unable to store data', 'An error occured while saving data, please try again later.\nError: ' + Utilities.getResponseBody(error), MessageSeverity.error, error);
                    }
                  }

                  setTimeout(() => {
                    this.isLoading = false;
                  }, 500);
                });

            // await this.apiService.postData(val);
            // API call succeeded, resolve the Promise
          } catch (error) {
            // API call failed, reject the Promise to prevent closing the popup
            return Promise.reject(error);
          }
        }
      },
    }).then((result) => {
      if (result.isConfirmed) {
        // Handle success case when the API call is successful
      } else if (result.isDenied) {
        // Handle the case when the user cancels the dialog
      } else if (result.isDismissed) {
        // Handle the case when the dialog is closed without confirmation
      }
    });
  }

  CreateForm() {
    this.icdForm = this.fb.group({
      US_or_CA: ['', Validators.required],
      Full_Legal_Company_Name: [{ value: '', disabled: true }],
      Distributor_Code: [{ value: '', disabled: true }],
       
      Is_primary_location: ['', Validators.required],
      
      ICD_Owner_Name: [{ value: '', disabled: true }],
      Address: [{ value: '', disabled: true }],
      Company_Address2: [{ value: '', disabled: true }],
      Company_City: [{ value: '', disabled: true }],
      Company_Postal_Code: [{ value: '', disabled: true }],
      Company_Office_Phone: [{ value: '', disabled: true }],
      Company_Business_Email: [{ value: '', disabled: true }],
      Company_Country: [{ value: '', disabled: true }],
      Company_State: [{ value: '', disabled: true }],
      Company_Province: [{ value: '', disabled: true }],
      
       


      Promoting_Owner: [{ value: '', disabled: true }],
      Regional_Consultant: [{ value: '', disabled: true }],
      
      National_Consultant: [{ value: '', disabled: true }],
      selectedRow: [],
      Location_Type: [{ value: '', disabled: true }]

    });


  }

  sendDataToParent() {
    this.dataEmitter.emit(this.datad);
  }
  // convenience getter for easy access to form fields
  get f() { return this.icdForm.controls; }

  get s1() { return this.section1Form.controls; }

  get items(): FormArray {
    return this.icdForm.get('items') as FormArray;
  }

  onPrimaryChange() {
    const Is_primary_location = this.icdForm.get('Is_primary_location').value;
    if (Is_primary_location === 'Yes') {
      this.Is_primary_location = true;

      //const mainLocation = this.Locs_Data.find(loc => loc.location_Type == 'Main');
      //if (mainLocation) {
      //  this.icdForm.get('selectedRow')?.setValue(mainLocation.id);
        
      //}

    }
    else {
      this.Is_primary_location = false;

      //const salettileLocation = this.Locs_Data.find(loc => loc.location_Type == 'Satellite');
      //if (salettileLocation) {
      //  this.icdForm.get('selectedRow')?.setValue(salettileLocation.id);
        
      //}
    }

    

  }


  onCountryChange() {
    const US_or_CA = this.icdForm.get('US_or_CA').value;
    if (US_or_CA === 'US') {
      this.selectedCountry = "US";
      

      this.icdForm.get('Company_Country').setValidators([Validators.required]);
      this.icdForm.get('Company_State').setValidators([Validators.required]);
      this.icdForm.get('Company_Province').clearValidators();
       

    } else {
      this.selectedCountry = "Canada";
      

      this.icdForm.get('Company_Country').clearValidators();
      this.icdForm.get('Company_State').clearValidators();
      this.icdForm.get('Company_Province').setValidators([Validators.required]);
       



    } 

    this.icdForm.get('Company_Country').updateValueAndValidity();
    this.icdForm.get('Company_State').updateValueAndValidity();
    this.icdForm.get('Company_Province').updateValueAndValidity();
     
  }

  onCheckboxChange_US_Retails(event: any, value: any) {
    if (event.target.checked) {
      this.US_Retails_selectedItems.push(value);
    } else {
      const index = this.US_Retails_selectedItems.indexOf(value);
      if (index > -1) {
        this.US_Retails_selectedItems.splice(index, 1);
      }
    }


    if (this.US_Retails_selectedItems.length <= 0) {
      this.US_Retails_isSelectedItemsinvalid = true;
    }
    else {
      this.US_Retails_isSelectedItemsinvalid = false;
    }


  }


  onCheckboxChange_Canada_Retails(event: any, value: any) {
    if (event.target.checked) {
      this.Canada_Retails_selectedItems.push(value);
    } else {
      const index = this.Canada_Retails_selectedItems.indexOf(value);
      if (index > -1) {
        this.Canada_Retails_selectedItems.splice(index, 1);
      }
    }


    if (this.Canada_Retails_selectedItems.length <= 0) {
      this.Canada_Retails_isSelectedItemsinvalid = true;
    }
    else {
      this.Canada_Retails_isSelectedItemsinvalid = false;
    }


  }


  onCheckboxChange_US_Campaigns(event: any, value: any) {

    if (event.target.checked) {
      if (value == "TestCampaign(NotListed)") {
        this.isTestCampaign = true;
        this.icdForm.get('TestCampaignNotListed').setValidators([Validators.required]);
        this.icdForm.get('TestCampaignNotListed').updateValueAndValidity();

      }
      this.US_Campaigns_selectedItems.push(value);
    } else {
      this.isTestCampaign = false;
      this.icdForm.get('Company_Country').clearValidators();
      this.icdForm.get('TestCampaignNotListed').updateValueAndValidity();
      const index = this.US_Campaigns_selectedItems.indexOf(value);
      if (index > -1) {
        this.US_Campaigns_selectedItems.splice(index, 1);
      }
    }


    if (this.US_Campaigns_selectedItems.length <= 0) {
      this.US_Campaigns_isSelectedItemsinvalid = true;
    }
    else {
      this.US_Campaigns_isSelectedItemsinvalid = false;
    }


  }


  onCheckboxChange_Canada_Campaigns(event: any, value: any) {
    if (event.target.checked) {
      this.Canada_Campaigns_selectedItems.push(value);
    } else {
      const index = this.Canada_Campaigns_selectedItems.indexOf(value);
      if (index > -1) {
        this.Canada_Campaigns_selectedItems.splice(index, 1);
      }
    }


    if (this.Canada_Campaigns_selectedItems.length <= 0) {
      this.Canada_Campaigns_isSelectedItemsinvalid = true;
    }
    else {
      this.Canada_Campaigns_isSelectedItemsinvalid = false;
    }


  }

  showErrorAlert(caption: string, message: string) {
    this.alertService.showMessage(caption, message, MessageSeverity.error);
  }
  ngAfterViewInit() {

    

    //if (this.selectEl) {
    //  $(this.selectEl.nativeElement).select2({ width: '100%' });
    //};

    //setTimeout(() => {
    //  $('.select2', this.elRef.nativeElement).select2();
    //}, 0);
    
    //$(this.datepicker.nativeElement).datepicker({
    //  dateFormat: 'yyyy-mm-dd',
    //  autoclose: true,
    //  onSelect: (date) => {
    //    this.dobInput.nativeElement.value = date;
    //  }
    //});

    //$('.select2').select2(); //initialize 
  }

  closeModal() {
    if (this.modalClosedCallback) {
      this.modalClosedCallback();
    }
  }

  onSubmit() {
    this.hintStateService.collapse();

    this.submitted = true;
    this.trimFormValues();
    // stop here if form is invalid
    if (this.icdForm.invalid) {

      // Mark all fields as touched to display validation errors
      this.icdForm.markAllAsTouched();

      return;
    }


    const selectedValue = this.icdForm.get('Is_primary_location').value;
    if (selectedValue === 'Yes' && (this.icdForm.get('selectedRow').value == '' || this.icdForm.get('selectedRow').value == null)) {
      this.alertService.showMessage('ICD', `Please select the new Main Location.`, MessageSeverity.error);
      this.Showsuccesspopup1('Please select the new Main Location.');
      return;
    } 


    
    if (selectedValue === 'Yes' && this.Locs_Data.length <= 0) {
      // Show error message or perform other actions
      this.alertService.showMessage('ICD', `The ICD has to have at least 2 locations in order to close the Main Location.`, MessageSeverity.error);
      this.Showsuccesspopup1('The ICD has to have at least 2 locations in order to close the Main Location.');
      return;
    }

    //if (selectedValue === 'No' && this.Locs_Data.length == 1) {
    //  // Show error message or perform other actions
    //  this.alertService.showMessage('ICD', `selected location is the ICD’s Primary location.`, MessageSeverity.error);
    //  let isdeined = false;
    //  Swal.fire({
    //    title: 'ICD!',
    //    text: 'selected location is the ICD’s Primary location.',
    //    icon: 'warning',
    //    confirmButtonText: 'Yes',
    //    showDenyButton: false,
    //    allowOutsideClick: false,
    //    allowEscapeKey: false,
    //    denyButtonText: 'No',
       
    //    showLoaderOnConfirm: true,  // Show a loading spinner while the API call is in progress
    //    preConfirm: async (val) => {
        
    //    },
    //  }).then((result) => {
    //    if (result.isConfirmed) {
    //      this.saveData(true);
    //    } else if (result.isDenied) {
    //      isdeined = true;
    //      return;
    //      // Handle the case when the user cancels the dialog
    //    } else if (result.isDismissed) {
    //      // Handle the case when the dialog is closed without confirmation
    //    }
    //  });
     
      
    //}

    this.showPreSubmitReview = true;
    this.runPreSubmitReview();

  }



  Showsuccesspopup1(str: string) {
    Swal.fire({
      title: str,
      icon: 'error',
      confirmButtonText: 'Ok',
      allowOutsideClick: false,
      allowEscapeKey: false,

      showLoaderOnConfirm: true,  // Show a loading spinner while the API call is in progress
      preConfirm: async (val) => {
        if (val) {

          //location.reload();
        }
      },
    }).then((result) => {

    });
  }

  fileValidator(control: any) {
    const files = control.value;
    
    if (!files || files.length === 0) {
      return null;
    }
    if (files.length + this.fileData.length > this.maxFilesAllowed) {
      return { maxFilesExceeded: true };
    }

    for (let i = 0; i < files.length; i++) {
      const file = files[i];
      if (!this.isValidFileFormat(file)) {
        return { invalidFormat: true };
      }

      if (file.size > this.maxFileSize) {
        return { fileSizeExceeded: true };
      }
    }

    return null;
  }

  //onFileSelected(event: any, inputId: string) {

  //  const files = event.target.files;


  //  for (let i = 0; i < files.length; i++) {
  //    const file = files[i];

  //    if (!this.isValidFileFormat(file)) {
  //      //console.log('Invalid file format:', file.name);
  //      this.icdForm.get('Attach_US_Articles_of_Incorporation').setErrors({ invalidFormat: true });

  //      continue;
  //    }

  //    const reader = new FileReader();
  //    reader.readAsDataURL(file);

  //    reader.onload = () => {
  //      const base64 = reader.result.toString().split(',')[1];
  //      this.fileData.push({ name: file.name, base64 });

  //      // Update the 'Attach_1' form control with the selected file name
  //      this.icdForm.patchValue({ Attach_US_Articles_of_Incorporation: file.name });

  //    };
  //  }

  //  this.uploadFiles();
  //}

  onFileSelected(event: any, controlName: string) {
    const files = event.target.files;
    const errorMessages: string[] = [];
    if (!files || files.length === 0) {
      // Remove files only for the specific control
      this.fileData = this.fileData.filter(file => file.attachment_Type !== controlName);
      this.icdForm.get(controlName).setErrors({ noFileSelected: true });
      return;
    }

    // Remove previously selected files for this control while keeping others
    this.fileData = this.fileData.filter(file => file.attachment_Type !== controlName);


    const errors = [];

    for (let i = 0; i < files.length; i++) {
      const file = files[i];

      if (!this.isValidFileFormat(file)) {
        errorMessages.push(
          `Invalid file format for "${file.name}". 
     Allowed formats: all image files (JPG, PNG, HEIC, etc.), PDF, Word (DOC, DOCX), Excel (XLS, XLSX), and CSV.`
        );

        //console.log('Invalid file format:', file.name);
        errors.push({ invalidFormat: true });
      }

      if (file.size > this.maxFileSize) {
        errorMessages.push(`File size exceeds 25 MB limit for file "${file.name}".`);
        //console.log('File size exceeds the limit:', file.name);
        errors.push({ fileSizeExceeded: true });
      }
    }

    if (errors.length > 0) {
      const combinedMessage = errorMessages.join('\n');

      this.alertService.showMessage(combinedMessage, '.', MessageSeverity.error);
      this.Showsuccesspopup1(combinedMessage);
      this.icdForm.get(controlName).setErrors(errors.reduce((acc, curr) => ({ ...acc, ...curr }), {}));
      const control = this.icdForm.get(controlName);
      // 🔥 CRITICAL FIX
      control?.setValue(null);
      control?.setErrors(errors.reduce((acc, curr) => ({ ...acc, ...curr }), {}));
      control?.markAsTouched();
      control?.updateValueAndValidity({ emitEvent: false });

      // optional: clear DOM input too
      event.target.value = '';
      return; // 👈 stop here
    } else {
      for (let i = 0; i < files.length; i++) {
        const file = files[i];

        const reader = new FileReader();
        reader.readAsDataURL(file);

        reader.onload = () => {
          const b64 = reader.result.toString().split(',')[1];
          this.fileData.push({ attachment_FileName: file.name, attachment_Base64: b64, attachment_Type: controlName });
        };
      }

      this.icdForm.get(controlName).setErrors(null);
    }
  }


  isInvalid(controlName: string): boolean {
    const control = this.icdForm.get(controlName);
    return control.touched && control.invalid;
  }


  public openFile(name: string, type: string): void {
    this.getBase64DownloadUrl(name, type).then((url: string) => {
      window.open(url, '_blank');
    });
  }

  public getBase64DownloadUrl(name: string, type: string): Promise<string> {
    const file = this.fileData.find(f => f.attachment_FileName === name && f.attachment_Type === type);

    if (file) {
      const fileExtension = this.getFileExtension(name);
      const mimeType = this.getMimeType(fileExtension);
      const base64Data = file.attachment_Base64;

      return Promise.resolve(`data:${mimeType};base64,${base64Data}`);
    } else {
      return Promise.reject(new Error('File not found.'));
    }
  }


  private getFileExtension(fileName: string): string {
    const fileExtension = fileName.split('.').pop().toLowerCase();
    return fileExtension;
  }


  private getMimeType(fileExtension: string): string {
    // Map the file extension to the corresponding MIME type
    const mimeTypeMap = {
      pdf: 'application/pdf',
      jpg: 'image/jpeg',
      jpeg: 'image/jpeg',
      png: 'image/png',
      xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      xls: 'application/vnd.ms-excel',
      csv: 'text/csv'
    };

    return mimeTypeMap[fileExtension];
  }


  isValidFileFormat(file: File): boolean {
    const allowedMimePrefixes = [
      'image/' // all image types (jpg, png, heic, webp, etc.)
    ];

    const allowedExactMimeTypes = [
      // PDF
      'application/pdf',

      // Word
      'application/msword',
      'application/vnd.openxmlformats-officedocument.wordprocessingml.document',

      // Excel
      'application/vnd.ms-excel',
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',

      // CSV (different browsers report it differently)
      'text/csv',
      'application/csv',
      'text/plain'
    ];

    // 1️⃣ Primary check (modern browsers)
    if (file.type) {
      if (allowedMimePrefixes.some(prefix => file.type.startsWith(prefix))) {
        return true;
      }

      if (allowedExactMimeTypes.includes(file.type)) {
        return true;
      }
    }

    // 2️⃣ Fallback (Safari / iOS / older browsers)
    const allowedExtensions = [
      // images
      'jpg', 'jpeg', 'png', 'gif', 'webp', 'heic', 'heif',

      // documents
      'pdf', 'doc', 'docx',

      // excel
      'xls', 'xlsx',

      // csv
      'csv'
    ];

    const extension = file.name.split('.').pop()?.toLowerCase();
    return !!extension && allowedExtensions.includes(extension);
  }


  uploadFiles() {
    //const formData = new FormData();

    //for (let i = 0; i < this.validFiles.length; i++) {
    //  formData.append('files[]', this.validFiles[i]);
    //}

    //console.log(this.fileData)
    //this.http.post('https://example.com/upload', formData).subscribe(
    //  (response) => {
    //    //console.log('Upload successful', response);
    //  },
    //  (error) => {
    //    //console.log('Upload error', error);
    //  }
    //);
  }


  // Check if the first five fields are valid
  areFirstFiveFieldsValid(firstFiveFields: any): boolean {


    for (const fieldName of firstFiveFields) {
      const fieldControl = this.icdForm.get(fieldName);
      if (fieldControl && fieldControl.invalid) {
        return false;
      }
    }

    return true;
  }

  // Example implementation of getErrorMessage function
  getErrorMessage(fieldName: string): string {
    const control = this.icdForm.get(fieldName);

    if (control?.errors) {
      if (control.errors.required) {
        return 'This field is required.';
      }
      // Add additional error messages for specific validation rules as needed
    }

    return 'Invalid field.';
  }
   
  saveData(isSubmitted: boolean) {
    //debugger;
    this.isLoading = true;
    this.btnDisplay = false;
    this.alertService.startLoadingMessage('', 'Data Submitting...');

    // Get the form values as an object
    const formValues = this.icdForm.getRawValue();



    // Set the properties of the ICD instance with the form values
    this.icd.US_or_CA = formValues.US_or_CA;
    //this.icd.Full_Legal_Company_Name = formValues.Full_Legal_Company_Name;
    
    this.icd.Is_primary_location = formValues.Is_primary_location;
    this.icd.Owner_Address1 = formValues.selectedRow;


    const selectedValue = this.icdForm.get('Is_primary_location').value;
    const selectedRow = this.icdForm.get('selectedRow').value;
    



    if (selectedValue === 'Yes' && this.Locs_Data.length >= 0) {

      this.icd.CompanyWebsite = this.Locs_Data.filter(a => a.id == selectedRow)[0].name;
      //this.icd.Company_City = this.Locs_Data.filter(a => a.id == selectedRow)[0].city;
      //this.icd.Company_State = this.Locs_Data.filter(a => a.id == selectedRow)[0].state__c;
      //this.icd.Company_Province = this.Locs_Data.filter(a => a.id == selectedRow)[0].state__c;
      //this.icd.Company_Postal_Code = this.Locs_Data.filter(a => a.id == selectedRow)[0].postal_Code;
      //this.icd.Company_Address1 = this.Locs_Data.filter(a => a.id == selectedRow)[0].address;
    }

    this.icd.IsSubmitted = isSubmitted;
    //console.log(this.icd);
    this.SaveDatatoDB();

  }


  ShowSuccesspopup() {
    Swal.fire({
      title: 'Data Saved Successfully!',
      icon: 'success',
      confirmButtonText: 'Ok',
      allowOutsideClick: false,
      allowEscapeKey: false,

      showLoaderOnConfirm: true,  // Show a loading spinner while the API call is in progress
      preConfirm: async (val) => {
        if (val) {

        }
      },
    }).then((result) => {
      let url = '/icdreport/';
      this.router.navigate([url]);
    });
  }

  SaveDatatoDB() {
    Swal.fire({
      title: 'Submitting data...',
      allowOutsideClick: false,
      allowEscapeKey: false,
      didOpen: () => {
        Swal.showLoading();
      }
    });
    // Create a new instance of the ICD class
    let responseAPI = new ResponseAPI();
    this.sfDataService.CreateICDClose(this.icd)
      .subscribe(
        data => {
          Swal.close();
          //responseAPI = data;
          // Assign the received data to the responseAPI object
          responseAPI = data;
          if (responseAPI.isSuccess && !responseAPI.isValidationError) {
           // location.reload();

            this.alertService.showMessage('ICD', `Data Saved Successfully`, MessageSeverity.success);
            this.alertService.stopLoadingMessage();
            this.isLoading = false;
            this.ShowSuccesspopup();
            //setTimeout(() => {
            //  this.alertService.showMessage('ICD', `Data Saved Successfully`, MessageSeverity.success);
            //  this.alertService.stopLoadingMessage();
            //  this.isLoading = false;


            //}, 200);
          }
          else {

            let errors = new ErrorList();
            errors = responseAPI.data;
            //setTimeout(() => {
            this.alertService.showMessage('ICD', `Error while saving Data`, MessageSeverity.error);
            this.alertService.stopLoadingMessage();
            this.isLoading = false;
            this.alertService.showStickyMessage('Unable to store data', errors.error.message, MessageSeverity.error, errors.error.errorCode);


            //}, 200);

          }

        },
        error => {
          Swal.close();
          this.alertService.stopLoadingMessage();

          if (Utilities.checkNoNetwork(error)) {
            this.alertService.showStickyMessage(Utilities.noNetworkMessageCaption, Utilities.noNetworkMessageDetail, MessageSeverity.error, error);
            this.offerAlternateHost();
          } else {
            const errorMessage = Utilities.getHttpResponseMessage(error);

            if (errorMessage) {
              this.alertService.showStickyMessage('Unable to store data', this.mapLoginErrorMessage(errorMessage), MessageSeverity.error, error);
            } else {
              this.alertService.showStickyMessage('Unable to store data', 'An error occured while saving data, please try again later.\nError: ' + Utilities.getResponseBody(error), MessageSeverity.error, error);
            }
          }

          setTimeout(() => {
            this.isLoading = false;
          }, 500);
        });

  }

  numberValidator(control: FormControl) {
    const isValid = /^\d+$/.test(control.value);
    return isValid ? null : { 'invalidNumber': true };
  }

  BindDropdowns() {
    //debugger;
    this.isLoading = true;
    this.alertService.startLoadingMessage('', 'Data loading...');

    //this.icd.Owner_Email = this.icdForm.value["Owner_email"];
    this.sfDataService.getMasterConfigs("US_State,Canada_Province,US_Retails,US_Campaigns,Canada_Retails,Canada_Campaigns,DeliveryTime")
      .subscribe(
        data => {
          ////console.log(data);
          //debugger;
          this.masterConfig = data;
          this.ddlUSStates = this.masterConfig.filter(a => a.type == "US_State");
          this.ddlCAProvinence = this.masterConfig.filter(a => a.type == "Canada_Province");
          //this.Canada_campaignData = this.masterConfig.filter(a => a.type == "Canada_Campaigns");
          //   this.Canada_retailsData = this.masterConfig.filter(a => a.type == "Canada_Retails");
          // this.US_campaignData = this.masterConfig.filter(a => a.type == "US_Campaigns");
          //  this.US_retailsData = this.masterConfig.filter(a => a.type == "US_Retails");
          this.ddlBest_Delivery_Time = this.masterConfig.filter(a => a.type == "DeliveryTime");
          this.alertService.stopLoadingMessage();
        },
        error => {

          this.alertService.stopLoadingMessage();

          if (Utilities.checkNoNetwork(error)) {
            this.alertService.showStickyMessage(Utilities.noNetworkMessageCaption, Utilities.noNetworkMessageDetail, MessageSeverity.error, error);
            this.offerAlternateHost();
          } else {
            const errorMessage = Utilities.getHttpResponseMessage(error);

            if (errorMessage) {
              this.alertService.showStickyMessage('Unable to get data', this.mapLoginErrorMessage(errorMessage), MessageSeverity.error, error);
            } else {
              this.alertService.showStickyMessage('Unable to get data', 'An error occured while saving data, please try again later.\nError: ' + Utilities.getResponseBody(error), MessageSeverity.error, error);
            }
          }

          setTimeout(() => {
            this.isLoading = false;
          }, 500);
        });

    

    this.sfDataService.getAddInfoDDs().subscribe(resp => {
      ////console.log(resp);

      let res: any;

      res = resp;
      this.NC_namesData = res.ncNames.filter(item => !item.name.startsWith('test') && !item.name.startsWith('smart circle'));;
      this.RC_namesData = res.rcNames.filter(item => !item.name.startsWith('test') && !item.name.startsWith('smart circle'));;
      this.PO_namesData = res.poNames.filter(item => !item.name.startsWith('test') && !item.name.startsWith('smart circle'));;
      // $('.select2').select();
      ////console.log(this.NC_namesData)

      ////console.log(this.Canada_campaignData)
    });


    const sanitizedId = this.id;
    this.sfDataService.getICDLocationsByAccount(sanitizedId).subscribe(resp => {
      //console.log(resp);

      let res: any;

      res = resp;

      this.Locs_Data = res.filter(item => !item.location_Type.startsWith('Main') );;;
      // $('.select2').select();
      ////console.log(this.NC_namesData)

      ////console.log(this.Canada_campaignData)
    });


  }

  private mapDataToICD(data: any) {
    if (data == null) {

      this.icdForm.disable();
      this.alertService.showMessage('ICD', `This Case is not assigned to view`, MessageSeverity.error);
      this.alertService.startLoadingMessage('', 'This Case is not assigned to view');
      this.alertService.showStickyMessage('ICD', 'This Case is not assigned to view', MessageSeverity.error, "");
      this.btnDisplay = false;

      return;
    }
    //debugger;
    this.icdForm.controls['US_or_CA'].setValue(data.uS_or_CA);
    this.onCountryChange();
    this.icdForm.controls['Full_Legal_Company_Name'].setValue(data.full_Legal_Company_Name);
   

    this.icdForm.controls['Address'].setValue(data.homeAddress);
    this.icdForm.controls['Company_Address2'].setValue(data.homeAddress2);
    //this.icdForm.controls['Company_Address2'].setValue(data.hUB_Manager_Contact_Email);
    this.icdForm.controls['Company_City'].setValue(data.homeCity);
    this.icdForm.controls['Company_Postal_Code'].setValue(data.zipCode);
    this.icdForm.controls['Company_Office_Phone'].setValue(data.homePhone);

    //this.icdForm.controls['Company_Country'].setValue(data.hUB_Manager_Contact_Email);
    this.icdForm.controls['Company_State'].setValue(data.state);
    this.icdForm.controls['Company_Province'].setValue(data.state);

    if (this.d != null) {
      this.icdForm.controls['Distributor_Code'].setValue(this.d);
      this.icd.Distributor_Code = this.d;
    }
    
    this.icdForm.controls['ICD_Owner_Name'].setValue(data.owner_Name);
    
    this.icdForm.controls['Promoting_Owner'].setValue(data.promotingOwner);
    
    this.icdForm.controls['Regional_Consultant'].setValue(data.regionalConsultant);
    
    this.icdForm.controls['National_Consultant'].setValue(data.nationalConsultant);

    this.icdForm.controls['Location_Type'].setValue(data.location_Type);


    if (data.location_Type == "Main") {
      this.icdForm.controls['Is_primary_location'].setValue('Yes');
      this.onPrimaryChange();
    }
    else {
      
      this.icdForm.controls['Is_primary_location'].setValue('No');
      this.onPrimaryChange();
    }
    
    ////console.log(data);

    this.icd.AccountID = data.accountID;

    this.icd.HUB_Manager_Contact = data.huB_Manager_Contact;
    this.icd.HUB_Manager_Contact_Name = data.huB_Manager_Contact_Name;
    this.icd.HUB_Manager_Contact_Number = data.huB_Manager_Contact_Number;
    this.icd.HUB_Manager_Contact_Email = data.huB_Manager_Contact_Email;
    this.icd.HUB_Assistance_Email = data.huB_Assistance_Email;
     
    this.icd.Company_Address1 = data.homeAddress;
    this.icd.Company_Address2 = data.homeAddress2;
    this.icd.Company_City = data.homeCity;
    this.icd.Company_Postal_Code = data.zipCode;
    this.icd.Company_Office_Phone = data.homePhone;
    this.icd.Company_State = data.state;
    this.icd.Company_Province = data.state;

    this.icd.Full_Legal_Company_Name = data.full_Legal_Company_Name;
    this.icd.Owner_First_Name = data.owner_First_Name;
    this.icd.Owner_Last_Name = data.owner_Last_Name;
    this.icd.Owner_Name = data.owner_Name;
    this.icd.PromotingOwner = data.promotingOwner;
    this.icd.PromotingOwnerCompany = data.promotingOwnerCompany;
    this.icd.RegionalConsultant = data.regionalConsultant;
    this.icd.RegionalConsultantCompany = data.regionalConsultantCompany;
    this.icd.NationalConsultant = data.nationalConsultant;
    this.icd.NationalConsultantCompany = data.nationalConsultantCompany;
    this.icd.CaseID = data.caseID;
    this.icd.ContactID = data.contactID;
    

    //if (data.status == "Closed") {

    //  this.icdForm.disable();
    //  this.alertService.showMessage('ICD', `ICD Closed Completed`, MessageSeverity.success);
    //  this.alertService.startLoadingMessage('', 'ICD Closed Completed');
    //  this.alertService.showStickyMessage('ICD', 'ICD Closed Completed', MessageSeverity.error, MessageSeverity.error);
    //  this.btnDisplay = false;
    //}
    this.dataEmitter.emit(this.datad);


  }

  BindData(id: string,dcode:string) {
    //debugger;

    this.isLoading = true;
    this.alertService.startLoadingMessage('', 'Data loading...');
    //this.icd.Owner_Email = this.icdForm.value["Owner_email"];
    if (this.f != null && this.d != null) {
      const sanitizedId = id;
      this.sfDataService.getICDStep3byAccJDE(sanitizedId,dcode)
      .subscribe(
        data => {
          //console.log(data);
          //debugger;

          this.mapDataToICD(data);
          ////console.log(data);


          this.alertService.stopLoadingMessage();
        },
        error => {

          this.alertService.stopLoadingMessage();

          if (Utilities.checkNoNetwork(error)) {
            this.alertService.showStickyMessage(Utilities.noNetworkMessageCaption, Utilities.noNetworkMessageDetail, MessageSeverity.error, error);
            this.offerAlternateHost();
          } else {
            const errorMessage = Utilities.getHttpResponseMessage(error);

            if (errorMessage) {
              this.alertService.showStickyMessage('Unable to get data', this.mapLoginErrorMessage(errorMessage), MessageSeverity.error, error);
            } else {
              this.alertService.showStickyMessage('Unable to get data', 'An error occured while saving data, please try again later.\nError: ' + Utilities.getResponseBody(error), MessageSeverity.error, error);
            }
          }

          setTimeout(() => {
            this.isLoading = false;
          }, 500);
        });
}
    else {
      this.sfDataService.getICDStep3(id)
        .subscribe(
          data => {
            ////console.log(data);
            //debugger;

            this.mapDataToICD(data);
            ////console.log(data);


            this.alertService.stopLoadingMessage();
          },
          error => {

            this.alertService.stopLoadingMessage();

            if (Utilities.checkNoNetwork(error)) {
              this.alertService.showStickyMessage(Utilities.noNetworkMessageCaption, Utilities.noNetworkMessageDetail, MessageSeverity.error, error);
              this.offerAlternateHost();
            } else {
              const errorMessage = Utilities.getHttpResponseMessage(error);

              if (errorMessage) {
                this.alertService.showStickyMessage('Unable to get data', this.mapLoginErrorMessage(errorMessage), MessageSeverity.error, error);
              } else {
                this.alertService.showStickyMessage('Unable to get data', 'An error occured while saving data, please try again later.\nError: ' + Utilities.getResponseBody(error), MessageSeverity.error, error);
              }
            }

            setTimeout(() => {
              this.isLoading = false;
            }, 500);
          });
}
    
  }

  mapLoginErrorMessage(error: string) {

    if (error === 'invalid_username_or_password') {
      return 'Invalid username or password';
    }

    if (error === 'invalid_grant') {
      return 'This account has been disabled';
    }

    return error;
  }

  offerAlternateHost() {

    if (Utilities.checkIsLocalHost(location.origin) && Utilities.checkIsLocalHost(this.configurations.baseUrl)) {
      this.alertService.showDialog('Dear Developer!\nIt appears your backend Web API service is not running...\n' +
        'Would you want to temporarily switch to the online Demo API below?(Or specify another)',
        DialogType.prompt,
        (value: string) => {
          this.configurations.baseUrl = value;
          this.alertService.showStickyMessage('API Changed!', 'The target Web API has been changed to: ' + value, MessageSeverity.warn);
        },
        null,
        null,
        null,
        this.configurations.fallbackBaseUrl);
    }
  }


  trimFormValues() {

    // Avoid setting value on file inputs. Skip controls that look like file attachments
    // (names starting with "Attach_") or whose value is a File/FileList/object.
    Object.keys(this.icdForm.controls).forEach(key => {
      // Skip known file-type controls
      if (/^Attach_/i.test(key) || /Attach/i.test(key)) {
        return;
      }

      const control = this.icdForm.get(key);
      if (!control) {
        return;
      }

      const val = control.value;

      // Skip File / FileList / object values to avoid InvalidStateError
      if (val instanceof File || (typeof FileList !== 'undefined' && val instanceof FileList) || typeof val === 'object') {
        return;
      }

      if (typeof val === 'string') {
        try {
          control.setValue(val.trim());
        } catch (e) {
          // don't break form processing on single control error
          console.warn(`trimFormValues: skipped trimming control '${key}' due to error`, e);
        }
      }
    });
  }

  noHtmlTagsValidator(control: any) {

    if (!control.value) {
      return null;
    }

    const value = control.value.toString().trim();

    const htmlPattern =
      /(<[^>]+>|&lt;|&gt;|javascript:|onerror=|onload=|<script|<\/script>)/gi;

    if (htmlPattern.test(value)) {
      return { invalidHtml: true };
    }

    return null;
  }
  reset() {
    this.formResetToggle = false;

    setTimeout(() => {
      this.formResetToggle = true;
    });
  }
  buildFormSnapshot(): Record<string, string> {
    const raw = this.icdForm.getRawValue();
    const snap: Record<string, string> = {};
    Object.keys(raw).forEach(k => {
      const ctrl = this.icdForm.get(k);
      if (ctrl && ctrl.disabled) { return; } // skip disabled/read-only fields — user cannot act on the advisory
      const v = raw[k];
      if (v !== null && v !== undefined && v !== '' && typeof v !== 'object') {
        snap[k] = String(v);
      }
    });
    return snap;
  }

  runPreSubmitReview(): void {
    this.preSubmitLoading = true;
    this.preSubmitIssues = [];
    const snapshot = this.buildFormSnapshot();
    this.agentService.getPreSubmitReview(snapshot).pipe(
      catchError(() => of({ issues: [] }))
    ).subscribe(res => {
      this.preSubmitIssues = res?.issues ?? [];
      this.preSubmitLoading = false;
    });
  }

  onPreSubmitDismiss(): void { this.showPreSubmitReview = false; }

  onPreSubmitDoSubmit(): void {
    this.showPreSubmitReview = false;
    this.saveData(true);
  }

  onPreSubmitRecheck(): void { this.runPreSubmitReview(); }

  onPreSubmitAutoFix(fix: { fieldName: string; suggestedFix: string }): void {
    const ctrl = this.icdForm.get(fix.fieldName);
    if (ctrl) { ctrl.setValue(fix.suggestedFix); ctrl.markAsDirty(); }
  }

  onPreSubmitNavigate(fieldName: string): void {
    const el = document.getElementById(fieldName) || document.querySelector(`[formcontrolname="${fieldName}"]`);
    if (el) (el as HTMLElement).scrollIntoView({ behavior: 'smooth', block: 'center' });
  }


}




